const searchFocus = () => {
    const searchHolder = document.querySelector('.search-wrapper');
    if (!searchHolder) return;

    const searchHolderSpan = searchHolder.querySelector('span');
    const holderInput = searchHolder.querySelector('input');

    if (!searchHolderSpan || !holderInput) return;

    const updatePlaceholder = () => {
        if (document.activeElement === holderInput) {
            searchHolderSpan.classList.add('active');
        } else {
            searchHolderSpan.classList.remove('active');
        }
    };

    searchHolderSpan.addEventListener('click', () => holderInput.focus());
    holderInput.addEventListener('focus', updatePlaceholder);
    holderInput.addEventListener('blur', updatePlaceholder);

    updatePlaceholder();
};

export default searchFocus;